import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LookupDocumentPreviewModalComponent } from './lookup-document-preview-modal/lookup-document-preview-modal.component';
import { isEducatorDocumentImageFileName } from './educator-document-download.util';

export interface EducatorDocumentPreviewOptions {
  title?: string;
}

@Injectable({ providedIn: 'root' })
export class EducatorDocumentPreviewModalService {
  constructor(
    private readonly modal: NgbModal,
    private readonly sanitizer: DomSanitizer
  ) {}

  openFromUrl(url: string, fileName?: string, options?: EducatorDocumentPreviewOptions): void {
    const isImage = isEducatorDocumentImageFileName(fileName || url);
    const previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    const ref = this.modal.open(LookupDocumentPreviewModalComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      windowClass: 'document-preview-modal'
    });
    ref.componentInstance.title = options?.title ?? 'View Document';
    ref.componentInstance.previewUrl = previewUrl;
    ref.componentInstance.isImage = isImage;
    ref.result.finally(() => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
  }

  openFromBlob(blob: Blob, fileName?: string, options?: EducatorDocumentPreviewOptions): void {
    const url = URL.createObjectURL(blob);
    this.openFromUrl(url, fileName, options);
  }
}
